import React from 'react';

const Expenses = () => <div>expenses</div>;

export default Expenses;
